import { LocationNumbersService } from '../../../services'

const fetchPhoneNumbersTollFreeStatus = async function (
  { commit, rootState, getters },
  locationId
) {
  const companyId = rootState?.company?.company?.id
  try {
    const { data } = await LocationNumbersService.getTollFreeStatus(
      companyId,
      locationId
    )
    const result = data?.tollFreeSidAndStatus

    commit('setTollFreeData', result)
    return Promise.resolve(result)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default fetchPhoneNumbersTollFreeStatus
